/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { FAQ } from '../model/fAQ';
import { FAQCreateInput } from '../model/fAQCreateInput';
import { FAQList } from '../model/fAQList';
import { FAQUpdateInput } from '../model/fAQUpdateInput';
import { Model15 } from '../model/model15';
import { Model61 } from '../model/model61';
import { Model62 } from '../model/model62';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FAQService {

    protected basePath = 'http://localhost:5001';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Delete a FAQ
     * 
     * @param orgName 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOrgsOrgnameFaqId(orgName: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteOrgsOrgnameFaqId(orgName: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteOrgsOrgnameFaqId(orgName: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteOrgsOrgnameFaqId(orgName: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling deleteOrgsOrgnameFaqId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteOrgsOrgnameFaqId.');
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/FAQ/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all FAQ(s)
     * 
     * @param orgName 
     * @param populate 
     * @param archived 
     * @param inlineBlob 
     * @param filter 
     * @param where 
     * @param offset 
     * @param page 
     * @param limit 
     * @param sortBy 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameFaq(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'body', reportProgress?: boolean): Observable<FAQList>;
    public getOrgsOrgnameFaq(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FAQList>>;
    public getOrgsOrgnameFaq(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FAQList>>;
    public getOrgsOrgnameFaq(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameFaq.');
        }










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (archived !== undefined && archived !== null) {
            queryParameters = queryParameters.set('archived', <any>archived);
        }
        if (inlineBlob !== undefined && inlineBlob !== null) {
            queryParameters = queryParameters.set('inlineBlob', <any>inlineBlob);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sortBy !== undefined && sortBy !== null) {
            queryParameters = queryParameters.set('sortBy', <any>sortBy);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FAQList>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/FAQ`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the count of all FAQ(s)
     * 
     * @param orgName 
     * @param where 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameFaqCount(orgName: string, where?: string, observe?: 'body', reportProgress?: boolean): Observable<Model15>;
    public getOrgsOrgnameFaqCount(orgName: string, where?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Model15>>;
    public getOrgsOrgnameFaqCount(orgName: string, where?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Model15>>;
    public getOrgsOrgnameFaqCount(orgName: string, where?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameFaqCount.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Model15>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/FAQ/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get FAQ
     * 
     * @param orgName 
     * @param id 
     * @param populate 
     * @param inlineBlob 
     * @param filter 
     * @param where 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameFaqId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'body', reportProgress?: boolean): Observable<FAQ>;
    public getOrgsOrgnameFaqId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FAQ>>;
    public getOrgsOrgnameFaqId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FAQ>>;
    public getOrgsOrgnameFaqId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameFaqId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrgsOrgnameFaqId.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (inlineBlob !== undefined && inlineBlob !== null) {
            queryParameters = queryParameters.set('inlineBlob', <any>inlineBlob);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FAQ>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/FAQ/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get FAQ field
     * 
     * @param orgName 
     * @param id 
     * @param fieldName 
     * @param populate 
     * @param q 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameFaqIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getOrgsOrgnameFaqIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getOrgsOrgnameFaqIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getOrgsOrgnameFaqIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameFaqIdFieldname.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrgsOrgnameFaqIdFieldname.');
        }

        if (fieldName === null || fieldName === undefined) {
            throw new Error('Required parameter fieldName was null or undefined when calling getOrgsOrgnameFaqIdFieldname.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any>q);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/FAQ/${encodeURIComponent(String(id))}/${encodeURIComponent(String(fieldName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a FAQ
     * 
     * @param orgName 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postOrgsOrgnameFaq(orgName: string, body?: FAQCreateInput, observe?: 'body', reportProgress?: boolean): Observable<FAQ>;
    public postOrgsOrgnameFaq(orgName: string, body?: FAQCreateInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FAQ>>;
    public postOrgsOrgnameFaq(orgName: string, body?: FAQCreateInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FAQ>>;
    public postOrgsOrgnameFaq(orgName: string, body?: FAQCreateInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling postOrgsOrgnameFaq.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<FAQ>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/FAQ`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Import multiple FAQ
     * 
     * @param orgName 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postOrgsOrgnameFaqImport(orgName: string, body?: Model61, observe?: 'body', reportProgress?: boolean): Observable<Model62>;
    public postOrgsOrgnameFaqImport(orgName: string, body?: Model61, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Model62>>;
    public postOrgsOrgnameFaqImport(orgName: string, body?: Model61, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Model62>>;
    public postOrgsOrgnameFaqImport(orgName: string, body?: Model61, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling postOrgsOrgnameFaqImport.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Model62>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/FAQ/import`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a FAQ
     * 
     * @param orgName 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putOrgsOrgnameFaqId(orgName: string, id: string, body?: FAQUpdateInput, observe?: 'body', reportProgress?: boolean): Observable<FAQ>;
    public putOrgsOrgnameFaqId(orgName: string, id: string, body?: FAQUpdateInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FAQ>>;
    public putOrgsOrgnameFaqId(orgName: string, id: string, body?: FAQUpdateInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FAQ>>;
    public putOrgsOrgnameFaqId(orgName: string, id: string, body?: FAQUpdateInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling putOrgsOrgnameFaqId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling putOrgsOrgnameFaqId.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<FAQ>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/FAQ/${encodeURIComponent(String(id))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Publish a FAQ
     * 
     * @param orgName 
     * @param id 
     * @param published 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putOrgsOrgnameFaqIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'body', reportProgress?: boolean): Observable<FAQ>;
    public putOrgsOrgnameFaqIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FAQ>>;
    public putOrgsOrgnameFaqIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FAQ>>;
    public putOrgsOrgnameFaqIdPublishedPublished(orgName: string, id: string, published: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling putOrgsOrgnameFaqIdPublishedPublished.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling putOrgsOrgnameFaqIdPublishedPublished.');
        }

        if (published === null || published === undefined) {
            throw new Error('Required parameter published was null or undefined when calling putOrgsOrgnameFaqIdPublishedPublished.');
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<FAQ>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/FAQ/${encodeURIComponent(String(id))}/published/${encodeURIComponent(String(published))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
